<template>
  <div class="search-conditions">
    <div class="row space">
      <div class="col two">
        <div class="title">상품 검색</div>
      </div>
    </div>

    <div v-if="tray">
      <div class="row">
        <div class="col">
          <div class="subtitle">상품 이름</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            class="span"
            v-model="productName"
            type="text"
            placeholder="상품이름을 입력해주세요."
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col">
          <div class="subtitle">회사 이름</div>
        </div>
        <div class="col">
          <div class="subtitle">사업자 번호</div>
        </div>
      </div>

      <div class="row">
        <div class="col two">
          <input
            class="span"
            v-model="companyName"
            type="text"
            placeholder="회사이름을 입력해주세요."
          />
        </div>
        <div class="col two">
          <input
            class="span"
            v-model="registrationNo"
            type="text"
            placeholder="사업자번호를 입력해주세요."
          />
        </div>
      </div>
    </div>

    <div class="row space">
      <div class="col">
        <button class="btn" @click="search">
          <img src="/static/img/ico-magnify.png" alt />
          상품 검색
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */

export default {
  props: [
    'tray',
  ],
  data: () => ({
    companyName: '',
    registrationNo: '',
    searchCondition: '',
    productName: '',
  }),
  created() {
  },
  methods: {
    numberAndDotFilter(data) {
      if (/^[\d\.]*$/.test(data.value)) {
        data.oldValue = data.value;
      } else if (data.oldValue) {
        data.value = data.oldValue;
      } else {
        data.value = '';
      }
    },
    search() {
      this.searchCondition = '';
      let companyName = '';
      let registrationNo = '';
      let productName = '';

      if (this.companyName) {
        companyName = this.companyName;
      }
      if (this.registrationNo) {
        registrationNo = this.registrationNo;
      }
      if (this.productName) {
        productName = this.productName;
      }

      let searchCondition = '';
      if (companyName) {
        searchCondition += `&companyName=${encodeURIComponent(companyName)}`;
      }
      if (registrationNo) {
        searchCondition += `&registrationNo=${encodeURIComponent(registrationNo)}`;
      }
      if (productName) {
        searchCondition += `&productName=${encodeURIComponent(productName)}`;
      }
      this.searchCondition = searchCondition.replace('&', '');

      this.$emit('search', this.searchCondition);
    },
    isValidDate(date) {
      if (!/^\d{4}.\d{2}.\d{2}$/.test(date)) {
        return false;
      }

      const parts = date.split('.');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);

      if (month === 0 || month > 12) {
        return false;
      }

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
      }

      return day > 0 && day <= monthLength[month - 1];
    },
    isValidTime(time) {
      if (!/^\d{2}:\d{2}$/.test(time)) {
        return false;
      }

      const parts = time.split(':');
      const hour = parseInt(parts[0], 10);
      const minute = parseInt(parts[1], 10);

      return hour >= 0 && hour < 24 && minute >= 0 && minute < 60;
    },
    convertDate(date) {
      const parts = date.split('.');
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      let ret = year;
      ret += '-';
      ret += month;
      ret += '-';
      ret += day;
      return ret;
    },
  },
};
</script>

<style scoped>
.search-conditions .row {
  display: flex;
  height: 56px;
}
.search-conditions .row.space {
  margin-top: 48px;
}
.search-conditions .row .col {
  flex: 1;
  width: 100%;
}
.search-conditions .row .col.space {
  margin-right: 48px !important;
}
.search-conditions .row .col.two {
  flex: 2;
}
.search-conditions .row .col:not(:last-child) {
  margin-right: 12px;
}
.search-conditions .title {
  margin-bottom: 26px;
}
.search-conditions .subtitle {
  margin-bottom: 12px;
  font-size: 14.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.19px;
  color: #212121;
}
.search-conditions input {
  padding: 16px 8px 16px 16px;
  width: 100%;
  height: 100%;
  border: solid 0.5px #686868;
}
.search-conditions input::placeholder {
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
  color: rgba(72, 72, 72, 0.64);
}
.search-conditions .select {
  position: relative;
}
.search-conditions .select select {
  padding: 16px;
  width: 100%;
  height: 100%;
  border: solid 0.5px #686868;
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
}
.search-conditions .select img {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 50%;
  right: 36px;
  transform: translate(0, -50%);
  cursor: pointer;
}
.search-conditions .btn {
  width: 100%;
  height: 56px;
  text-align: center;
  font-size: 12.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #ffffff;
  background-color: #0058ee;
  border-radius: 2px;
  transition: 0.2s;
  cursor: pointer;
}
.search-conditions .btn:hover {
  background-color: #0068fe;
}
.search-conditions .btn img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/product/SearchConditions.vue